import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconCheckUpgrade = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    viewBox="0 0 20 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#00FFE8"
      d="M18.75 5.5c0 .352-.156.664-.39.898l-10 10a1.212 1.212 0 0 1-.86.352c-.352 0-.664-.117-.898-.352l-5-5a1.237 1.237 0 0 1-.352-.898c0-.703.547-1.25 1.25-1.25.313 0 .625.156.86.39l4.14 4.102 9.102-9.101c.234-.235.546-.391.898-.391.664 0 1.25.547 1.25 1.25Z"
    />
  </svg>
));
export default SvgIconCheckUpgrade;
